import React from "react";
import { OrderStatus } from "../../../../../../../../../Interfaces/formValue-interfaces";
import useLanguagesHooks from "../../../../../../../../../Components/Languages/setLanguage-hooks";
import styles from './myOrdersStatus.module.scss';

interface MyOrderStatusProps {
  status: OrderStatus;
}

const statusColors: Record<OrderStatus, { background: string; color: string }> = {
  [OrderStatus.NEW]: { background: "rgba(243, 156, 18, 0.15)", color: "#f39c12" },
  [OrderStatus.PENDING]: { background: "rgba(243, 156, 18, 0.15)", color: "#f39c12" },
  [OrderStatus.ACCEPTED]: { background: "rgba(39, 174, 96, 0.15)", color: "#728600ff" },
  [OrderStatus.REJECTED]: { background: "rgba(231, 76, 60, 0.15)", color: "#e74c3c" },
  [OrderStatus.IN_PREPARATION]: { background: "rgba(155, 89, 182, 0.15)", color: "#9b59b6" },
  [OrderStatus.READY_FOR_PICKUP]: { background: "rgba(26, 188, 156, 0.15)", color: "#1abc9c" },
  [OrderStatus.OUT_FOR_DELIVERY]: { background: "rgba(41, 128, 185, 0.15)", color: "#2980b9" },
  [OrderStatus.DELIVERED]: { background: "rgba(46, 204, 113, 0.15)", color: "#2ecc71" },
  [OrderStatus.CANCELLED]: { background: "rgba(127, 140, 141, 0.15)", color: "#7f8c8d" },
};

export const MyOrderStatus: React.FC<MyOrderStatusProps> = ({ status }) => {
  const { t } = useLanguagesHooks();
  const colors = statusColors[status];

  return (
    <div
      className={styles.statusBadge}
      style={{
        backgroundColor: colors.background,
        color: colors.color,
      }}
    >
      {t(`My_Business.OrderStatus.${status}`)}
    </div>
  );
};
